var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtAcknowledge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M218.94 42.079c11.563 0 20.935 9.372 20.935 20.934v153.52c0 11.562-9.372 20.935-20.934 20.935H65.42c-11.562 0-20.935-9.373-20.935-20.935V63.013c0-11.562 9.373-20.934 20.935-20.934zm-23.806 50.588a6.98 6.98 0 0 0-4.935 2.045l-65.464 65.45-30.53-30.555a6.98 6.98 0 0 0-9.87 0l-9.869 9.87a6.98 6.98 0 0 0 0 9.87l45.358 45.358a6.98 6.98 0 0 0 9.87 0l-.004-.005 80.249-80.249a6.98 6.98 0 0 0 0-9.87l-9.87-9.87a6.98 6.98 0 0 0-4.935-2.044"
})));
export default SvgQtAcknowledge;